module.exports = __webpack_public_path__ + "static/looksafari-31614b6bee84e95249a9ef91b8c1d552.jpeg";